// import * as THREE from "three";
// import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Canvas, useFrame } from "@react-three/fiber";
import Experience from "./Experience.jsx";
import { PerspectiveCamera, Html } from "@react-three/drei";
import { Button,Image } from "antd";
import gsap from "gsap";
import { useRef, useEffect, useState, Suspense } from "react";
import TwoDUI_for_scene2 from "./TwoDUI_for_scene2.jsx";
import { IoClose } from "react-icons/io5";
import {
  PopupAcochill,
  Airportanimationbutton,
  PopupMountpermanent,
  Interprotoseriesbutton,
  PopupIsland,
} from "./Popups";
import { Perf } from "r3f-perf";


function Scene2(props) {
  const lang = useSelector((state) => state.reducer1.lang);

  const cameraRef = useRef();
  const [birdView, setBirdView] = useState(false);

  const [gallery, setGallery] = useState(0);

  const [campView, setCampView] = useState(false);
  const [acochillView, setacochillView] = useState(false);
  const [airportView, setairportView] = useState(false);
  const [mountView, setmountView] = useState(false);
  const [trackView, settrackView] = useState(false);
  const [islandView, setislandView] = useState(false);
  const [camZPos, setCamZPos] = useState(500);

  const groupRef = useRef();
  const mountfujibutton = useRef();
  const cont = useRef();

  var speed = 0.002;

  
  useEffect(()=>{
    if(window.innerWidth<900){
      setCamZPos(1200)
    }
    // else if(window.innerWidth<600){
    //   setCamZPos(1200)
    // }
      },[])

  function changeaboutustrue(about) {
  //   setAboutus(true);
  }

  function switchCamera() {
    if (cameraRef.current && birdView) {
      gsap.to(groupRef.current.rotation, {
        y: 0,
        duration: 2,
      });
    }

    setBirdView(!birdView);

    if (campView) {
      setCampView(false);
    }
    if(acochillView){
      setacochillView(false);
    }
    if(airportView){
      setairportView(false);
    }
    if(mountView){
      setmountView(false);
    }
    if(trackView){
      settrackView(false);
    }
    if(islandView){
      setislandView(false);
    }
    

    gsap.to(cameraRef.current.position, {
      x: 0,
      y: 250,
      z: camZPos+200,
      duration: 2,
    });
  }

  // var a = true;
  // var b = false;
  // var c = false;
  // var d = false;
  // var e = false;

  // var circum = 0;

  function CameraCircularPath() {
    useFrame(({ clock }) => {
      if (cameraRef.current) {
        if (gallery!=0) {
          cameraRef.current.lookAt(-285, 0, -150);
        } else {
          cameraRef.current.lookAt(0, 0, 0);
        }
      }

      if (groupRef.current && cameraRef.current && birdView) {
        groupRef.current.rotation.y += speed;

        // circum += speed;

        // if (speed == 0.004 || speed == 0.002) {
        //   if (circum > Math.PI / 4 && a) {
        //     a = false;
        //     b = true;
        //     gsap.to(cameraRef.current.position, {
        //       z: 720,
        //       duration: 2,
        //       ease: "power1.inOut",
        //     });
        //     console.log("track");
        //   } else if (circum > Math.PI / 2 && b) {
        //     b = false;
        //     c = true;
        //     gsap.to(cameraRef.current.position, {
        //       z: 500,
        //       duration: 2,
        //       ease: "power1.inOut",
        //     });
        //     console.log("mount");
        //   } else if (circum > (3 * Math.PI) / 4 && c) {
        //     c = false;
        //     d = true;
        //     gsap.to(cameraRef.current.position, {
        //       z: 700,
        //       duration: 2,
        //       ease: "power1.inOut",
        //     });
        //     console.log("airport");
        //   } else if (circum > (5 * Math.PI) / 4 && d) {
        //     d = false;
        //     e = true;
        //     gsap.to(cameraRef.current.position, {
        //       z: 700,
        //       duration: 2,
        //       ease: "power1.inOut",
        //     });
        //     console.log("station");
        //   } else if (circum > (7 * Math.PI) / 4 && e) {
        //     e = false;

        //     gsap.to(cameraRef.current.position, {
        //       z: 650,
        //       duration: 2,
        //       ease: "power1.inOut",
        //     });
        //     console.log("camp");
        //   } else if (circum > Math.PI * 2) {
        //     circum = 0;
        //     groupRef.current.rotation.y = 0;
        //     a = true;
        //   }
        // } else {
        //   if (circum < (7 * Math.PI) / 4 && d) {
        //     d = false;
        //     c = true;
        //     gsap.to(cameraRef.current.position, {
        //       z: 800,
        //       duration: 2,
        //       ease: "power1.inOut",
        //     });
        //     console.log("station");
        //   } else if (circum < (5 * Math.PI) / 4 && c) {
        //     c = false;
        //     b = true;
        //     gsap.to(cameraRef.current.position, {
        //       z: 700,
        //       duration: 2,
        //       ease: "power1.inOut",
        //     });
        //     console.log("airport");
        //   } else if (circum < (3 * Math.PI) / 4 && b) {
        //     b = false;
        //     a = true;
        //     gsap.to(cameraRef.current.position, {
        //       z: 500,
        //       duration: 2,
        //       ease: "power1.inOut",
        //     });
        //     console.log("mount");
        //   } else if (circum < Math.PI / 2 && a) {
        //     a = false;
        //     e = true;
        //     gsap.to(cameraRef.current.position, {
        //       z: 720,
        //       duration: 2,
        //       ease: "power1.inOut",
        //     });
        //     console.log("track");
        //   }
        //   if (circum < Math.PI / 4 && e) {
        //     e = false;
        //     gsap.to(cameraRef.current.position, {
        //       z: 650,
        //       duration: 2,
        //       ease: "power1.inOut",
        //     });
        //     console.log("camp");
        //   } else if (circum < 0) {
        //     circum = Math.PI * 2;
        //     groupRef.current.rotation.y = 0;
        //     d = true;
        //   }
        // }
      }
    });
    return null;
  }

  function handleScroll(event) {
    if (event.deltaY > 0) {
      // console.log("Scrolling down");
      speed = 0.004;
    } else if (event.deltaY < 0) {
      // console.log("Scrolling up");
      speed = -0.004;

      // if (circum > Math.PI / 4 && circum < Math.PI / 2) {
      //   a = true;
      //   b = false;
      //   c = false;
      //   d = false;
      //   e = false;
      // } else if (circum > Math.PI / 2 && circum < (3 * Math.PI) / 4) {
      //   a = false;
      //   b = true;
      //   c = false;
      //   d = false;
      //   e = false;
      // } else if (circum > (3 * Math.PI) / 4 && circum < (5 * Math.PI) / 4) {
      //   a = false;
      //   b = false;
      //   c = true;
      //   d = false;
      //   e = false;
      // } else if (circum > (5 * Math.PI) / 4 && circum < (7 * Math.PI) / 4) {
      //   a = false;
      //   b = false;
      //   c = false;
      //   d = true;
      //   e = false;
      // } else if (circum > (7 * Math.PI) / 4 && circum < Math.PI / 4) {
      //   a = false;
      //   b = false;
      //   c = false;
      //   d = false;
      //   e = true;
      // }
    }
  }
  let scrollTimeout;

  function handleScrollStop() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      // console.log("User has stopped scrolling");
      speed = 0.002;

      // if (circum > Math.PI / 4 && circum < Math.PI / 2) {
      //   a = true;
      //   b = false;
      //   c = false;
      //   d = false;
      //   e = false;
      // } else if (circum > Math.PI / 2 && circum < (3 * Math.PI) / 4) {
      //   a = false;
      //   b = true;
      //   c = false;
      //   d = false;
      //   e = false;
      // } else if (circum > (3 * Math.PI) / 4 && circum < (5 * Math.PI) / 4) {
      //   a = false;
      //   b = false;
      //   c = true;
      //   d = false;
      //   e = false;
      // } else if (circum > (5 * Math.PI) / 4 && circum < (7 * Math.PI) / 4) {
      //   a = false;
      //   b = false;
      //   c = false;
      //   d = true;
      //   e = false;
      // } else if (circum > (7 * Math.PI) / 4 && circum < Math.PI / 4) {
      //   a = false;
      //   b = false;
      //   c = false;
      //   d = false;
      //   e = true;
      // }
    }, 150);
  }

  window.addEventListener("wheel", function (event) {
    if (birdView) {
      handleScroll(event);
      handleScrollStop();
    }
  });

  function goToAirport() {
    if (cameraRef.current) {
      gsap.to(cameraRef.current.position, {
        duration: 2,
        x: -100,
        y: 70,
        z: -495,

        ease: "power1.inOut",
      });
      gsap.to(groupRef.current.rotation, {
        y: 0,
        duration: 2,
      });
    }
    setBirdView(false);
    setCampView(true);
    setairportView(true);
  }

  function goToTrack() {
    if (cameraRef.current) {
      gsap.to(cameraRef.current.position, {
        duration: 2,
        x: 518,
        y: 60,
        z: 160,

        ease: "power1.inOut",
      });
      gsap.to(groupRef.current.rotation, {
        y: 0,
        duration: 2,
      });
    }
    setBirdView(false);
    setCampView(true);
    settrackView(true);
  }

  function goToMount() {
    if (cameraRef.current) {
      gsap.to(cameraRef.current.position, {
        duration: 2,
        x: 160,
        y: 40,
        z: 258,

        ease: "power1.inOut",
      });
      gsap.to(groupRef.current.rotation, {
        y: 0,
        duration: 2,
      });
    }
    setBirdView(false);
    setCampView(true);
    setmountView(true);
  }

  function goToAcoChillCamp() {
    if (cameraRef.current) {
      gsap.to(cameraRef.current.position, {
        duration: 2,
        x: 0,
        y: 25,
        z: 370,
        ease: "power1.inOut",
      });
      gsap.to(groupRef.current.rotation, {
        y: 0,
        duration: 2,
      });
      setBirdView(false);
      setCampView(true);
      setacochillView(true);
    }
  }

  function goToStation() {
    if (cameraRef.current) {
      gsap.to(cameraRef.current.position, {
        duration: 2,
        x: -440,
        y: 70,
        z: 200,

        ease: "power1.inOut",
      });
      gsap.to(groupRef.current.rotation, {
        y: 0,
        duration: 2,
      });
    }
    setBirdView(false);
    setCampView(true);
    setislandView(true);
  }

  useEffect(() => {
    if (props.goToMount) {
      setTimeout(() => {
        if (cameraRef.current) {
          gsap.to(cameraRef.current.position, {
            duration: 2,
            x: 230,
            y: 450,
            z: camZPos+100,
            ease: "power1.inOut",
          });
        }
      }, 3500);
    }

    if (props.goToEarth && cameraRef.current) {
      gsap.to(cameraRef.current.position, {
        duration: 2,
        x: 0,
        y: 280,
        z: 740,
        ease: "power1.inOut",
      });
    }
  }, [props.goToMount, props.goToEarth]);

  // const acochillref = useRef();
  function Acochill(props) {
    // useFrame(() => {
    //   if (acochillref.current && groupRef.current && birdView) {
    //     acochillref.current.quaternion.copy(groupRef.current.quaternion);
    //   } else if (acochillref.current && cameraRef.current && !birdView) {
    //     acochillref.current.quaternion.copy(cameraRef.current.quaternion);
    //   }
    // });

    return (
      <>
        {/* <mesh ref={acochillref} scale={[10, 10, 10]} position={[-1.2, 28, 240]}>
          <boxGeometry args={[5, 5, 5]} />
          <meshStandardMaterial side={THREE.DoubleSide} visible={false} /> */}
          <Html
            // occlude={true}
            distanceFactor={190}
            // position={[0.4, 0.5, 3.4]}
            position={[25, 10, 240]}
            // transform
          >
            <Image
            className="acochillbutton"
            width={30}
            src="../img/imgone.jpeg" 
            preview={false}
            style={{transform:"scale(3)"}}
            onClick={goToAcoChillCamp}
            />
          </Html>
        {/* </mesh> */}
      </>
    );
  }

  // const airportref = useRef();
  function Airport(props) {
  
    return (
      <>
        {/* <mesh ref={airportref} scale={[10, 10, 10]} position={[-47, 42, -280]}>
          <boxGeometry args={[5, 5, 5]} />
          <meshStandardMaterial side={THREE.DoubleSide} visible={false} /> */}

          <Html
            // occlude={true}
            distanceFactor={100}
            // position={[0.4, 0.5, 3.4]}
            position={[-47, 42, -280]}
            // transform
          >
            <Button
              className="acochillbutton"
              style={{
                borderRadius: "20px",
                border: "0.5px solid",
                borderColor: "white",
                width: "120px",
                height: "25px",
                transform:"scale(3)"
              }}
              type="primary"
              onClick={goToAirport}
            >
              Airport
            </Button>
          </Html>
        {/* </mesh> */}
      </>
    );
  }

  // const interprotoref = useRef();
  function Interproto(props) {
    // const { camera } = useThree();

    // useFrame(() => {
    //   if (interprotoref.current && groupRef.current && birdView) {
    //     interprotoref.current.quaternion.copy(groupRef.current.quaternion);
    //   } else if (interprotoref.current && cameraRef.current && !birdView) {
    //     interprotoref.current.quaternion.copy(cameraRef.current.quaternion);
    //   }
    // });

    return (
      <>
        {/* <mesh
          ref={interprotoref}
          scale={[10, 10, 10]}
          position={[290, 35, 100]}
        >
          <boxGeometry args={[5, 5, 5]} />
          <meshStandardMaterial side={THREE.DoubleSide} visible={false} /> */}

          <Html
            // occlude={true}
            distanceFactor={100}
            // position={[0.4, 0.5, 3.4]}
            position={[290, 35, 100]}
            // transform
          >
            <Button
              className="acochillbutton"
              style={{
                borderRadius: "20px",
                border: "0.5px solid",
                borderColor: "white",
                width: "120px",
                height: "25px",
                transform:"scale(3)"
              }}
              type="primary"
              onClick={goToTrack}
            >
              Events
            </Button>
          </Html>
        {/* </mesh> */}
      </>
    );
  }

  // const mountfujiref = useRef();
  function MountFuji(props) {
    // const { camera } = useThree();

    // useFrame(() => {
    //   if (mountfujiref.current && groupRef.current && birdView) {
    //     mountfujiref.current.quaternion.copy(groupRef.current.quaternion);
    //   } else if (mountfujiref.current && cameraRef.current && !birdView) {
    //     mountfujiref.current.quaternion.copy(cameraRef.current.quaternion);
    //   }
    // });

    return (
      <>
        {/* <mesh ref={mountfujiref} scale={[10, 10, 10]} position={[0, 30, 150]}>
          <boxGeometry args={[5, 5, 5]} />
          <meshStandardMaterial side={THREE.DoubleSide} visible={false} /> */}

          <Html ref={mountfujibutton} distanceFactor={190} position={[-4, 20, 150]}
         >
            {/* <Button
              className="acochillbutton"
              style={{
                borderRadius: "20px",
                border: "0.5px solid",
                borderColor: "white",
                width: "120px",
                height: "25px",
              }}
              type="primary"
              onClick={goToMount}
            >
              Mt.Fuji 100
            </Button> */}
            {/* <img
            src="../img/imgthree.png"
            style={{
              className: "acochillbutton",
              borderRadius: "50%",
              border: "1px solid",
              borderColor: "black",
              width: "26px",
              height: "26px",
            }}
            onClick={goToMount}>
            </img> */}
            <Image
            className="acochillbuttonmount"
            width={80}
            style={{transform:"scale(3)"}}
            src="../img/imgthreemt.png" 
            preview={false}
            onClick={goToMount}
            />
            
          </Html>
        {/* </mesh> */}
      </>
    );
  }

  // const islandref = useRef();
  function Island(props) {
    // useFrame(() => {
    //   if (islandref.current && groupRef.current && birdView) {
    //     islandref.current.quaternion.copy(groupRef.current.quaternion);
    //   } else if (islandref.current && cameraRef.current && !birdView) {
    //     islandref.current.quaternion.copy(cameraRef.current.quaternion);
    //   }
    // });

    return (
      <>
        {/* <mesh ref={islandref} scale={[10, 10, 10]} position={[-250, 44, 80]}>
          <boxGeometry args={[5, 5, 5]} />
          <meshStandardMaterial side={THREE.DoubleSide} visible={false} /> */}

          <Html
            // occlude={true}
            distanceFactor={100}
            // position={[0.4, 0.5, 3.4]}
            position={[-250, 44, 80]}
            // transform
          >
            <Button
              className="acochillbutton"
              style={{
                borderRadius: "20px",
                border: "0.5px solid",
                borderColor: "white",
                width: "120px",
                height: "25px",
                transform:"scale(3)"
              }}
              type="primary"
              onClick={goToStation}
            >
              Island
            </Button>
          </Html>
        {/* </mesh> */}
      </>
    );
  }

  function goToNewsPoster() {
    // console.log("news clicked");
    gsap.to(groupRef.current.rotation, {
      y: 0,
      duration: 2,
    });
    setBirdView(false);
    setGallery(2);
    gsap.to(cameraRef.current.position, {
      duration: 2,
      x: -240,
      y: 28,
      z: -110,
      ease: "power1.inOut",
    });
  }
  function camToPosters() {
    setGallery(1);
    gsap.to(cameraRef.current.position, {
      duration: 2,
      x: -220,
      y: 70,
      z: 0,
      ease: "power1.inOut",
    });
  }
  function galleryClose() {
    if(gallery==1){
      
      gsap.to(cameraRef.current.position, {
        x: -450,
        y: 70,
        z: 200,
        duration: 2,
      });
    }
    else if(gallery==2){

      gsap.to(cameraRef.current.position, {
        x: 0,
        y: 250,
        z: 710,
        duration: 2,
      });
    }
    setGallery(0);
  }
  function newsCick(){

    if(gallery==1){
      gsap.to(cameraRef.current.position, {
        duration: 2,
        x: -240,
        y: 28,
        z: -110,
        ease: "power1.inOut",
      });
    }
  }


  return (
    <div ref={cont} className="cont">
      
      <TwoDUI_for_scene2
    
        goToNewsPoster={() => {
          goToNewsPoster();
        }}
      />

      {/* {aboutus && (
        <AboutPhilosophy
          cancelAbout={() => {
            setAboutus(false);
          }}
        />
      )} */}

      {gallery==0 && (
          <button onClick={switchCamera} id="birdBtn">
          <span class="button_top">
            {lang === "en" ? "Bird's View" : "鳥の眺め"}
          </span>
        </button>
      )}

      <div style={{ width: "100vw", height: "100vh" }}>
        <div id="text-tank-container">
          <div id="text-box-tank">
            <img
              className="tank-img-tank"
              src="../img/tank.jpg"
              alt="whiskey"
            />
            <h2 id="header-camp-tank">White whiskey tank</h2>
            <p className="hoverCardText">
              This white whiskey tank is decorated with an original mark on the
              lid, which gives a sense of unity with Acochillcamp. The clean and
              sophisticated design reflects the camp's theme of "harmony with
              nature". The tank is made by local artisans and is durable and
              beautiful. Visitors can sample whiskey around the campfire.
            </p>
          </div>
        </div>

        <div id="text-asset-container">
          <div id="text-box-asset">
            <img
              className="tank-img-asset"
              src="../img/asset.jpeg"
              alt="whiskey"
            />
            <h2 id="header-camp-asset">Wolf-shaped tree</h2>
            <p className="hoverCardText">
              This decoration is a tree that recreates the shape of a wolf by
              skillfully combining multiple natural branches. It was carefully
              assembled by hand, one by one, using local materials. The design
              symbolizes the strength and beauty of nature. This tree is a
              popular photo spot, and visitors can experience a sense of unity
              with nature.
            </p>
          </div>
        </div>

        <div id="text-signboard-container">
          <div id="text-box-signboard">
            <img
              className="tank-img-signboard"
              src="../img/signboard.jpg"
              alt="whiskey"
            />
            <h2 id="header-camp-signboard">Camp information board</h2>
            <p className="hoverCardText">
              This post is equipped with multiple arrows and provides a guide to
              various spots within Acochillcamp. Visitors can use this post as a
              reference to find various activities and facilities within the
              camp. Each sign is colored and designed to match the theme of the
              spot, and also serves as an element that tickles the camp's sense
              of exploration.
            </p>
          </div>
        </div>

        <div id="text-signboard-mountain">
          <div id="text-box-mountain">
            <img
              className="tank-img-mountain-one"
              src="../img/mountone.png"
              alt="whiskey"
            />
            <img
              className="tank-img-mountain-two"
              src="../img/mounttwo.png"
              alt="whiskey"
            />
            <h2 id="header-camp-mountain">Mt.Fuji 100</h2>
            <p className="mountain">
              Mt.Fuji
              100は毎年開催される、富士山を舞台にしたエクストリームレースイベントです。参加者は富士山の壮大な自然を体感しながら、様々なチャレンジを乗り越えることが求められます。このイベントは、トレイルランニング、サイクリング、ハイキングなど、複数のスポーツを組み合わせたユニークなレースとなっています。
            </p>
            <p className="mountain-two">
              主な特徴:
              <br />
              場所: 富士山エリア
              <br />
              距離: 100キロメートル
              <br />
              種目: トレイルランニング、サイクリング、ハイキング
              <br />
              参加資格: 18歳以上の健康な成人
              <br />
              日時: 毎年6月の第3週末
              <br />
              参加費:
              15,000円（エントリーフィーには保険料とエイドステーションの利用料が含まれます）
            </p>
          </div>
        </div>

        {gallery!=0 && (
          <div
            onClick={galleryClose}
            style={{
              position: "absolute",
              bottom: "1rem",
              left: "49vw",
              fontSize: "4rem",
              cursor: "pointer",
              zIndex: "1000000",
              color: "white",
            }}
          >
            <IoClose />
          </div>
        )}

        <Canvas
          id="maincanvas"
          // shadows={true}
          gl={{ localClippingEnabled: true }}
        >

          {/* <axesHelper args={[400]} /> */}

          {/* <Perf position="top-left" /> */}

          <group ref={groupRef}>
            <PerspectiveCamera
              ref={cameraRef}
              fov={45}
              near={10}
              far={100000}
              position={[0, 100, camZPos]}
              makeDefault
            />
          </group>

          <Suspense fallback={null}>
            <CameraCircularPath />

            {!campView && <Acochill />}

            {!campView && <Airport />}

            {!campView && <Interproto />}

            {!campView && <Island />}

            {!campView && <MountFuji />}

            {acochillView && <PopupAcochill />}

            {airportView && (
              <Airportanimationbutton changeaboutustrue={changeaboutustrue} />
            )}

            {mountView && <PopupMountpermanent />}

            {trackView && <Interprotoseriesbutton />}

            {islandView && (
              <PopupIsland
                goToPosters={() => {
                  camToPosters();
                }}
              />
            )}

            <Experience birdView={birdView} gallery={gallery} newsClick={()=>{newsCick()}}/>
          </Suspense>
        </Canvas>
      </div>
    </div>
  );
}

export default Scene2;
